import { IonButton , IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonLoading , IonSpinner , useIonViewDidEnter , useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import Box from "@mui/material/Box";
import { DataGrid , deDE } from "@mui/x-data-grid";
import { useContext , useEffect , useState } from "react";
import { useHistory } from 'react-router-dom';
import { defColumn , exportTableData } from './_HelperFunctions' ;
import { useEinweisungGeraeteThemen } from '../components/_CustomHooks';
import { Hourglass, ThumbsDown , ThumbsUp } from 'react-ionicons';
import { AppContext } from "../contexts/app_context";
import './table_einweisungen_grid.css'

export default function EinweisungenMatrix() {
  useIonViewWillEnter( () => setMatrixLoading( true ) ) ;
  useIonViewDidEnter(() => {
    appEinweisungenMatrixBuildNewChange( true ) ;
    // setMatrixLoading( true )
    // console.log( 'ionViewDidEnter table_matrix' ) ;
  });
  useIonViewWillLeave(() => {
    setTableData( [] )
    appEinweisungNeuTeilnehmerChange( '' ) ;
    appEinweisungNeuThemaChange( '' ) 
    // console.log( 'ionViewWillLeave table_matrix' ) ;
  });
  /** Component Environment */
    const { appBetriebeName , appEinweisungGeraeteThemen , appEinweisungenIdChange , appEinweisungenListeData , appEinweisungenListeFetchState , appEinweisungenMatrixBuildNew ,appEinweisungenMatrixBuildNewChange , appEinweisungNeuTeilnehmer , appEinweisungNeuTeilnehmerChange , appEinweisungNeuThema , appEinweisungNeuThemaChange , appEinweisungsThemenListe , appMitarbeiterListe , appViewSwitchChange } = useContext( AppContext ) ;
    const [ tableData , setTableData ] = useState( Array() ) ;
    const [ einweisungNeuThemaTitel , setEinweisungNeuThemaTitel ] = useState( '' ) ;
    const history = useHistory();
    const [ localEinweisungsThemenListe , setLocalEinweisungsThemenListe ] = useState( appEinweisungsThemenListe ) ;
    const [ matrixLoading , setMatrixLoading ] = useState( true ) ;
    const [pageSize, setPageSize] = useState(50);
      // NB: "fetchState" bzw. "setFetchState" momentan nur für Syntax getDate()
  /** Component Helpers */
    const HOTFIX_horizontal_slider = () => 
      {
        Array.from( document.querySelectorAll( '.MuiDataGrid-virtualScroller' ) ).forEach( ( entry ) => 
          {
            if( entry.style.overflowX === 'hidden' ) {
              entry.style.overflowX = 'unset' ;
              // console.log( 'XUGGA', 'hidden => unset' ) ;
            }
          }
        ) ; 
        return true ;
      }
    ;
    const matrixCheckbox = 
      ( einweisungsthemaId , mitarbeiter , einweisungsthemaTitel ) =>
        {
          // alert( 'Aktion: Mitarbeiter ID ' + mitarbeiter + ' zu neuer Einweisung zum Thema ' + einweisungsthemaId + ' hinzufügen ODER entfernen' )
          // alert( 'appEinweisungNeuThema: ' + appEinweisungNeuThema +'\nappEinweisungNeuTeilnehmer:' + appEinweisungNeuTeilnehmer )
          //#region Numerische IDs via Prä- und Suffix eindeutig machen
            let myAppEinweisungNeuTeilnehmer = ',' + appEinweisungNeuTeilnehmer + ',' ;
            let myMitarbeiter =  ',' + mitarbeiter + ',' ;
              //#endregion Numerische IDs via Prä- und Suffix eindeutig machen
          //#region "mitarbeiter" hinzufügen oder entfernen
            if( myAppEinweisungNeuTeilnehmer.includes( myMitarbeiter ) ) {
              // alert( '"' + myMitarbeiter + '" IST in "' + myAppEinweisungNeuTeilnehmer + '"' ) ;
              /** "mitarbeiter" lokal entfernen, weil noch für "thema" unten benötigt */
                myAppEinweisungNeuTeilnehmer = myAppEinweisungNeuTeilnehmer.replace( myMitarbeiter , '' ) ;
              appEinweisungNeuTeilnehmerChange( myAppEinweisungNeuTeilnehmer ) ;
            } else {
              // alert( '"' + myMitarbeiter + '" ist NICHT in "' + myAppEinweisungNeuTeilnehmer + '"' ) ;
              /** "mitarbeiter" lokal hinzufügen, weil noch für "thema" unten benötigt */
                myAppEinweisungNeuTeilnehmer += ',' + mitarbeiter ;
              appEinweisungNeuTeilnehmerChange( myAppEinweisungNeuTeilnehmer ) ;
            }
              //#endregion "mitarbeiter" hinzufügen oder entfernen
          //#region "einweisungsthemaId" hinzufügen oder entfernen wenn alle "mitarbeiter" entfernt wurden
            if( myAppEinweisungNeuTeilnehmer.replaceAll( ',' , '' ) !== '' ) {
              // alert( 'Mitarbeiter "' + myAppEinweisungNeuTeilnehmer + '" => Thema dazu' ) ;
              appEinweisungNeuThemaChange( einweisungsthemaId ) ;
              setEinweisungNeuThemaTitel ( einweisungsthemaTitel ) ;
            } else {
              // alert( 'Mitarbeiter "' + myAppEinweisungNeuTeilnehmer + '" => Thema weg' ) ;
              appEinweisungNeuThemaChange( '' ) ;
              setEinweisungNeuThemaTitel( '' ) ;
            }
              //#endregion "einweisungsthemaId" hinzufügen oder entfernen wenn alle "mitarbeiter" entfernt wurden
        }
    ;
    const matrixHourglass =
      ( einweisungsthemaId , mitarbeiter , next ) =>
        {
          // ! s. Ticket 27/5/22: Funktionalität zurückgestellt als "Erweiterungs-Feature"
          // alert( 'Aktion: Zeige geplante Einweisung zum Thema ID ' + einweisungsthemaId + ' mit Mitarbeiter ID ' + mitarbeiter ) 
          appViewSwitchChange( true ) ;
          appEinweisungenIdChange ( next ) ;
          history.push( '/einweisung/' + next ) ;
        }
    ;
    const matrixThumb = 
      ( einweisungsthemaId , mitarbeiter , next ) =>
        {
          // alert( 'Aktion: Zeige Einweisung ID ' + next + ' als neueste Einweisung zum Thema ID ' + einweisungsthemaId + ' für Mitarbeiter ID ' + mitarbeiter ) 
          appViewSwitchChange( true ) ;
          appEinweisungenIdChange ( next ) ;
          history.push( '/einweisung/' + next ) ;
        }
    ;
    const setColumns = () => {
      const mkEinweisungsColumns = ( colsArray )  => 
        {
          localEinweisungsThemenListe
            .forEach(
              ( { SchulungenId , SchulungenTitel } ) =>
                {
                  // if( SchulungenTitel.includes( 'g' ) ) {
                  if(
                    appEinweisungGeraeteThemen
                      .find(
                        ( thema ) =>
                          thema.ThemaId === SchulungenId
                          &&
                          thema.GeraetId !== ''
                      )
                  )
                    {
                      let newCol =
                        {
                          align: 'center' ,
                          field: 'matrixEinweisungsthema' + SchulungenId ,
                          flex: 0 ,
                          description: SchulungenTitel ,
                          headerName: SchulungenTitel ,
                          headerClassName: "super-app-theme--header , datagrid-vertical-head",
                          width: 120 ,
                          renderCell: ( params ) => {
                            // return <><IonCheckbox onClick={ () => matrixCheckbox( SchulungenId , params.row.MitarbeiterId ) } />&nbsp;<ThumbsUp color = { params.row.value.split(1)[0] } onClick={ () => matrixThumb( SchulungenId , params.row.MitarbeiterId ) }/>params.row.value.split(1)[1]==''?&nbsp;<Hourglass onClick={ () => matrixHourglass( SchulungenId , params.row.MitarbeiterId , SchulungenTitel) } />:''</>
                            let myData = params.row[ 'matrixEinweisungsthema' + SchulungenId ].split( ',' ) ;
                            let mitarbeiterRowInfo = params.row.Personalnummer + ' ' + params.row.Nachname + ', ' + params.row.Vorname + ' (' + params.row.Taetigkeit + ' ' + params.row.Abteilung + ')' ;
                            return (
                              <>
                                { 
                                  myData[0] === 'red'
                                    ? 
                                      <ThumbsDown
                                        color = { myData[0] }
                                        style = { { cursor: 'not-allowed' } }
                                        title = { 'Keine gültige Einweisung gefunden für ' + mitarbeiterRowInfo }
                                      />
                                    :
                                      <ThumbsUp
                                        color = { myData[0] }
                                        onClick = { () => matrixThumb( SchulungenId , params.row.MitarbeiterId , myData[ 1 ] ) }
                                        style = { { cursor: 'pointer' } }
                                        title = { 'zur letzten stattgefundenen Einweisung für ' + mitarbeiterRowInfo }
                                      />
                                }
                                &nbsp;
                                {
                                  myData[ 2 ]
                                    ? 
                                      <Hourglass
                                        onClick = { () => matrixHourglass( SchulungenId , params.row.MitarbeiterId , myData[ 2 ] ) }
                                        style = { { cursor: 'pointer' } }
                                        title = { 'zur nächsten geplanten Einweisung für ' + mitarbeiterRowInfo }
                                      />
                                    :
                                      <IonCheckbox
                                        /** "checked" explizit für Reset bei Re-Rendering */
                                          // checked = { false }
                                        onClick = { () => matrixCheckbox( SchulungenId , params.row.MitarbeiterId , SchulungenTitel ) }
                                        title = { 'Neue Einweisung planen mit ' + mitarbeiterRowInfo }
                                        />
                                }
                              </>
                            )
                          }
                        }
                      colsArray.push( newCol ) ;
                    }
                  ;
                }
            )
        }
      let cols =
        [
          defColumn( 'MitarbeiterId' , 'ID' , 0 ) ,
          defColumn( 'Personalnummer' , 'Personalnummer' , 80 , 0 ) ,
          defColumn( 'Nachname' , 'Nachname' , 150 , 0 ) ,
          defColumn( 'Vorname' , 'Vorname' , 100 , 0 ) ,
          defColumn( 'Geburtsdatum' , 'Geb.datum' , 50 , 0 ) ,
          defColumn( 'Taetigkeit' , 'Tätigkeit' , 200 , 0 ) ,
          defColumn( 'Abteilung' , 'Abteilung' , 200 , 0 ) ,
        ]
      mkEinweisungsColumns( cols )
      return cols
    }
    const exportButtonDataEntry = ( entry ) =>
    {
      let labelledEntry =
        {
          Personalnummer: entry.Personalnummer ,
          Nachname: entry.Nachname ,
          Vorname: entry.Vorname ,
          Geburtsdatum: new Date( entry.Geburtsdatum ).toLocaleDateString() ,
          'Tätigkeit': entry.Taetigkeit ,
          Abteilung: entry.Abteilung
        }
      let colsThemen = 
        Object.keys( entry )
        .filter(
          ( thema ) =>
            thema.includes( 'matrixEinweisungsthema' )
        )
      colsThemen
        .forEach(
          ( thema ) =>
            {
              labelledEntry[
                localEinweisungsThemenListe
                  .find( 
                    ( { SchulungenId } ) => SchulungenId === thema.substring( 22 )
                  ).SchulungenTitel
              ] =
                entry[ thema ].includes( 'green' )
                  ?
                    'OK'
                  :
                    entry[ thema ].split( ',' )[ 2 ] === ''
                      ?
                        '-'
                      :
                        'geplant'
            }
        )
      // alert( colsThemen ) ;
      return labelledEntry ;
    }
    const exportButton = () =>
      <IonButton
        onClick =
          {
            () =>
              exportTableData(
                tableData.map( ( entry ) => exportButtonDataEntry( entry ) )
                ,
                'Einweisungen ' + appBetriebeName + ' Übersicht'
              )
          }
      >
        Exportieren
      </IonButton>
  /** Component Mount-Update */
    // useEinweisungenListe() ;
    // useEinweisungsThemen() ;
    // useMitarbeiterListe() ;
    useEinweisungGeraeteThemen() ;
    useEffect(
      () =>
        {
          setLocalEinweisungsThemenListe(
            appEinweisungsThemenListe
              .filter(
                ( entry ) => entry.SchulungenAktiv === 'aktiv'
              )
          ) ;
        } ,
        [ appEinweisungsThemenListe ]
    ) ;
    useEffect(
      () => {
        //#region Startzeit als potentieller Trigger
          /** Startzeit für Durchlauf - evtl. später verwenden für Erzwingung Re-Rendering
           *  - konkret für Zurücksetzen Checkboxen in Matrix ist u.U. ein Re-Rendern nötig,
           *    auch wenn sich die eigentlichen Date nicht geändert haben, deshalb "settime"
           *    dann als künstlich geänderte Daten
           *    - noch unklar: wo kann man "settime" platzieren, ohne dass es zuviel Last
           *      erzeugt? ist eine eigene Spalte viel Last oder verhältnismäßig wenig?
           *    - NB: die Checkboxes liegen in DataGrid, i.e. ohne direkten Zugriff; auch
           *      bei direktem Zugriff würde vermutlich jede Checkbox-Änderung ein separates
           *      Re-Rendern auslösen, deshalb besser Komplett-Re-Rendern
           */
            // let starttime = Date.now() ;
            // console.log( 'useEffect Matrix ' + starttime ) ;
            //#endregion Startzeit als potentieller Trigger
        //#region Helper-Funktion mkMatrtixData
          /** historisch gewachsen als Funktion, evtl. umstellbar zu unmittelbarem Code */
            const mkMatrixData = () => {
              //#region Row-Liste initialisieren
                /** DataGrid erwartet Array */
                  let matrixData = [] ;
                  //#endregion Row-Liste initialisieren
              //#region Row pro Mitarbeiter generieren
                /** muss jeweils komplett lokal (neu) initialisiert werden, damit nicht Referenzen
                 *  auf vorherige Rows statt tatsächlich neuen Rows hinzugefügt werden
                 */
                  appMitarbeiterListe
                    .filter(
                      ( entry ) => entry.MitarbeiterAktiv === 'aktiv'
                    )
                    .forEach(
                      ( entry ) =>
                        {
                          //#region Mitarbeiter-Zeile initialisieren
                            let matrixDataRow = {} ;
                              //#endregion Mitarbeiter-Zeile initialisieren
                          //#region Mitarbeiterdaten
                            /** MitarbeiterId für Weiterverarbeitung und als eindeutige RowId = key für DataGrid */
                              matrixDataRow.MitarbeiterId = entry.MitarbeiterId ;
                            /** Anzuzeigende Daten */
                              matrixDataRow.Personalnummer = entry.MitarbeiterPersonalnummer ;
                              matrixDataRow.Nachname = entry.MitarbeiterNachname ;
                              matrixDataRow.Vorname = entry.MitarbeiterVorname ;
                              matrixDataRow.Geburtsdatum = entry.MitarbeiterGeburtsdatum ;
                              matrixDataRow.Taetigkeit = entry.MitarbeiterTaetigkeit ;
                              matrixDataRow.Abteilung = entry.MitarbeiterAbteilung ;
                              //#endregion Mitarbeiterdaten
                          //#region Einweisungsdaten
                            //#region Spalten für Einweisungsthemen
                              /** Hinzufügen für neue Einweisung, Status letzte Einweisung, evtl. bereits geplante Einweisung */
                              /** Rückgabe für Anzeige + Sortierung: Tupel "colorString,hourglassBool"
                               *    - colorString: 'green' | 'red' | 'yellow'
                               *      - keine Abkürzungen, da diese wieder rechenintensiv ausgewertet werden
                               *        müssten
                               *    - hourglassBool: '1' | nil
                               *      - für (hoffentlich) unaufwändigste Auswertung
                               *      - Logik: "if( tupel.split(1)[1] == '' )" => hourglassTRUE
                               *        => wenn mit "1" als Splitter das Feld 1 nicht "undefined" ist sondern leer,
                               *           dann war eine "1" angegeben
                               *    - Bsp.:
                               *      - "red" = roter Daumen, keine Sanduhr
                               *      - "red1" = roter Daumen und Sanduhr
                               */
                              //#region Vorhandene Einweisungsthemen iterieren
                                  localEinweisungsThemenListe.forEach(
                                    ( { SchulungenId } ) =>
                                      {
                                        let myDates = [] ;
                                        //#region Vorhandene Einweisungstermine iterieren
                                          //#region Reduktion auf Einweisungen zum Thema
                                            myDates = appEinweisungenListeData.filter(
                                              ( einweisung ) => einweisung.EinweisungenThema === SchulungenId
                                            )
                                            //#region Reduktion auf Einweisungen mit Mitarbeiter als Teilnehmer
                                              myDates = myDates.filter(
                                                ( einweisung ) => ( ( ',' + einweisung.EinweisungenMitarbeiterId + ',').includes( ',' + entry.MitarbeiterId + ',' ) ) 
                                              )
                                              // console.log( 'myDates für ' + entry.MitarbeiterNachname + ' betrefffs ' + SchulungenId + ': ' + myDates )
                                              //#region Auswerten
                                                /** Newest: ID für neueste stattgefundene Einweisung zum Thema
                                                 *  - bleibt leer wenn = bislang noch nie Einweisung stattgefunden
                                                 */
                                                  let myNewest = '' ;
                                                /** Daumen: Default "red"
                                                 *  - trifft zu für "überhaupt keine Einweisung vorhanden" und "Einweisung abgelaufen"
                                                 *  - zu überschreiben in allen anderen Fällen
                                                 */
                                                  let myDaumen = 'red' ;
                                                /** Planned: ID für geplante Einweisung zum Thema
                                                 *  - bleibt leer wenn = aktuell keine Einweisung geplant
                                                 */
                                                  let myPlanned = '' ;
                                                /** Gefundene Einweisungen prüfen  */
                                                  if( myDates.length !== 0 ) {
                                                    //#region Abgeschlossene auswerten
                                                      let myDatesAbgeschlossen = myDates.filter(
                                                        ( einweisung ) => einweisung.EinweisungenStatus === 'abgeschlossen' 
                                                      )
                                                      if( myDatesAbgeschlossen.length !== 0 ) {
                                                        /** TODO rot vs. gelb vs. grün bezüglich Turnus lt. Einweisungsthema
                                                         *  - i.e. abgelaufen, bald ablaufend (3 Monate!), noch ausreichend gültig
                                                        */
                                                        // MOCK grün
                                                        myDaumen = 'green' ;
                                                        /** ID für neueste gefundene Einweisung */
                                                          let myDatesAbgeschlossenNewest = myDatesAbgeschlossen.sort(
                                                            ( a , b ) =>
                                                              {
                                                                if ( a.EinweisungenTermin > b.EinweisungenTermin ) { return 1 ; }
                                                                if ( a.EinweisungenTermin < b.EinweisungenTermin ) { return -1 ; }
                                                                return 0 ;
                                                              }
                                                          )
                                                          myNewest = myDatesAbgeschlossenNewest[ 0 ].EinweisungenId ;
                                                      }
                                                        //#endregion Abgeschlossene auswerten
                                                    //#region auf offene prüfen = Sanduhr
                                                      /** Reine Existenzprüfung genügt */
                                                        let myDatesOpen = myDates.filter(
                                                          ( einweisung ) => einweisung.EinweisungenStatus === 'offen' 
                                                        )
                                                        if ( myDatesOpen.length !== 0 ) {
                                                          /** ID für neueste gefundene Einweisung */
                                                            let myDatesOpenNext = myDatesOpen.sort(
                                                              ( a , b ) =>
                                                                {
                                                                  if ( a.EinweisungenTermin > b.EinweisungenTermin ) { return 1 ; }
                                                                  if ( a.EinweisungenTermin < b.EinweisungenTermin ) { return -1 ; }
                                                                  return 0 ;
                                                                }
                                                            )
                                                          myPlanned = myDatesOpenNext[ 0 ].EinweisungenId ;
                                                        }
                                                        //#endregion auf offene prüfen = Sanduhr
                                                  }
                                                /** Resultat setzen  */
                                                  matrixDataRow[ 'matrixEinweisungsthema' + SchulungenId ] = myDaumen + ',' + myNewest + ',' + myPlanned ;
                                                  //#endregion Auswerten
                                                //#endregion Reduktion auf Einweisungen mit Mitarbeiter als Teilnehmer
                                              //#region Reduktion auf Einweisungen zum Thema
                                            //#endregion Vorhandene Einweisungstermine iterieren
                                      }
                                  )
                                  //#endregion Vorhandene Einweisungsthemen iterieren
                                //#endregion Spalten für Einweisungsthemen
                              //#endregion Einweisungsdaten
                          matrixData.push( matrixDataRow ) ;
                        }
                    )
                  //#endregion Row-Liste initialisieren
              // console.log( 'async??:', matrixData ) ;
              return matrixData
            }
            //#endregion Helper-Funktion mkMatrtixData
        setTableData( mkMatrixData() )
        appEinweisungenMatrixBuildNewChange( false ) ;
        // console.log( 'useEffect Matrix Out ' + Date.now() ) ;
      } ,
      [ appEinweisungenMatrixBuildNew , appEinweisungenListeData , localEinweisungsThemenListe , appMitarbeiterListe ]
    ) 
/** Component UI */
    return (
      <IonCard>
        <IonCardHeader>
          <IonCardTitle>
            Überblick
          </IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          {/* <IonButton
            onClick={ () => setMatrixLoading( true ) }
          >
            TEST: Loading-Spinner start
          </IonButton> */}
          <IonLoading
            // cssClass = 'einweisungen_matrix'
            isOpen = { matrixLoading }
            onDidDismiss={() => setMatrixLoading( false ) }
            message = '  .'
            // message = { localEinweisungsThemenListe.length + ', ' + appMitarbeiterListe.length }
            duration = { 
              localEinweisungsThemenListe.length > 0
                ? 
                  localEinweisungsThemenListe.length * ( appMitarbeiterListe.length + 1)  * 3
                :
                  3000
            }
          />
          <Box
              sx={{
                height: 500 ,
                width: 1,
                "& .super-app-theme--header": {
                  backgroundColor: "rgb(211,211,211)",
                },
              }}
            >
              {
                HOTFIX_horizontal_slider() && appEinweisungenListeFetchState === 100 ? (
                  <IonSpinner name="bubbles" />
                ) : (
                  <DataGrid
                    headerHeight = { 120 }
                    // "loading" muss offenbar anderweitig wieder auf "false" gesetzt werden
                    // loading = { true }
                    disableVirtualization
                    /** sorting: appMitarbeiterListe initial nach Nachname sortiert, also auch matrixData */ 
                      // initialState={{
                      //   sorting: {
                      //     sortModel: [ { field: 'Nachname' , sort: 'asc' } ] ,
                      //   },
                      // }}
                    getRowId = { (row) => row.MitarbeiterId }
                    rows={ tableData }
                    columns={ setColumns() } 
                    rowsPerPageOptions={[50,100]}
                    disableSelectionOnClick
                    onCellClick = {
                      ( e ) => { 
                          // appViewSwitchChange( true ) ;
                          // alert( 'Die Funktionalität zum Aktualisieren der Einweisungen pro MitarbeiterIn wird derzeit technisch überarbeitet und steht in Kürze wieder zur Verfügung.\n\nWir danken für Ihr Verständnis!' ) ;
                        // alert( e.field + ': ' + e.value )
                        return ;
                      }
                    }
                    pageSize={pageSize}
                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                    pagination
                    localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                  />
                )
              }
          </Box>
          {
            exportButton()
          }
          {
            appEinweisungNeuThema !== ''
              ?
                <IonButton onClick={ () => { appViewSwitchChange( true ) ; appEinweisungenIdChange( 'neu' ) ; history.push( "/einweisung/neu/" ) ; } }>Neue Einweisung "{ einweisungNeuThemaTitel }"</IonButton>
              :
                <IonButton disabled = { true }>Neue Einweisung</IonButton>
            }
        </IonCardContent>
      </IonCard>
    );
}
